// M09 - EducaFileGrid
//
// Rejilla responsiva de EducaFileCard. Maneja loading (skeleton),
// empty (con CTA opcional) y la paginacion.

import React from "react";
import { Row, Col, Empty, Pagination, Skeleton } from "antd";
import { EducaFileCard } from "./EducaFileCard";
import styles from "./EducaFileGrid.module.scss";

export function EducaFileGrid({
  files,
  total,
  loading,
  page,
  pageSize,
  onPageChange,
  buildStreamUrl,
  onCopyUrl,
  onEdit,
  onDelete,
  onPreview,
  onDownload,
  emptyHint,
}) {
  if (loading) {
    return (
      <Row gutter={[16, 16]}>
        {Array.from({ length: 8 }).map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Col key={`sk-${i}`} xs={24} sm={12} md={8} lg={6}>
            <div className={styles.skeleton}>
              <Skeleton.Image style={{ width: "100%", height: 160 }} active />
              <div style={{ padding: 12 }}>
                <Skeleton active paragraph={{ rows: 1 }} />
              </div>
            </div>
          </Col>
        ))}
      </Row>
    );
  }

  if (!files || files.length === 0) {
    return (
      <Empty
        description={emptyHint || "No hay ficheros en esta carpeta todavia."}
        style={{ padding: 48 }}
      />
    );
  }

  return (
    <>
      <Row gutter={[16, 16]}>
        {files.map((file) => (
          <Col key={file.id} xs={24} sm={12} md={8} lg={6}>
            <EducaFileCard
              file={file}
              streamUrl={buildStreamUrl(file.id)}
              onCopyUrl={onCopyUrl}
              onEdit={onEdit}
              onDelete={onDelete}
              onPreview={onPreview}
              onDownload={onDownload}
            />
          </Col>
        ))}
      </Row>

      {total > pageSize ? (
        <div className={styles.pagination}>
          <Pagination
            current={page}
            total={total}
            pageSize={pageSize}
            onChange={onPageChange}
            showSizeChanger={false}
            showTotal={(t) => `${t} fichero${t === 1 ? "" : "s"} en total`}
          />
        </div>
      ) : (
        <div className={styles.totalHint}>
          {total} fichero{total === 1 ? "" : "s"} en total
        </div>
      )}
    </>
  );
}
